import React from 'react';
import {Link} from 'react-router-dom';

import {HeaderProps} from './Props';

import './header.less';

import {MaintenanceAlert} from './MaintenanceAlert';

export const Header: React.StatelessComponent<HeaderProps> = (props) => (
  <nav className="site-header navbar navbar-fixed-top">
    <MaintenanceAlert></MaintenanceAlert>
    <div className="site-header-inner container-fluid">
      <div className="logos-nav">
        <div className="site-logos">
          <Link to="/" className="brand shawfloors-logo">Shaw Floors</Link>
        </div>
      </div>
      <div className="site-nav">
        <ul className="links">
          <li><Link to="/search">Designs</Link></li>
          {props.loading ? (
            <li><a href="#" className="disabled">Loading...</a></li>
          ) : props.authLinks.map((x, idx) => (
            <li key={idx}><Link to={x.url}>{x.name}</Link></li>
          ))}
        </ul>
        <div className="user-items">
          <Link to="/saved" className="item-btn saved-items">
            <span className="item-label">My Saved Designs</span>
          </Link>
          <Link to="/basket" className="item-btn basket-items">
            <span className="item-label">My Basket</span><span className="item-count">{props.basketCount}</span>
          </Link>
        </div>
      </div>
    </div>
  </nav>
);
